export default __webpack_public_path__ + "static/media/25.df7f840c.pdf";